import React, { useMemo } from 'react';
import { Button } from 'antd';

import { RenderIf } from 'components/components';
import { UserRoleType } from 'types/auth';
import { isEitherAdmin } from 'utils';

type UploadButtonProps = {
  name: string,
  onClick: React.MouseEventHandler<HTMLButtonElement>,
  condition: boolean,
  status: number | undefined,
  userType: UserRoleType,
}

const ViewUploadButton = (props: UploadButtonProps) => {
  const {
    name, onClick, condition, status, userType,
  } = props;

  const buttonText = useMemo(() => {
    if (condition) {
      return `View ${name} details`;
    }

    return `${status === 2 ? 'Change' : 'Upload'} ${name}`;
  }, [condition, status]);

  return (
    <div className="edit-angelinvestor__view-upload-button__container">
      {isEitherAdmin(userType) && !condition
        ? (
          <Button className="secondary-button md" onClick={onClick}>
            {buttonText}
          </Button>
        )
        : (
          <Button className="secondary-button md" onClick={onClick}>
            {buttonText}
          </Button>
        )}
      <RenderIf condition={status === 2 && !isEitherAdmin(userType)}>
        <p className="edit-angelinvestor__view-upload-button__rejected-document-text">{`Your ${name} has been rejected. Please upload a new one.`}</p>
      </RenderIf>
    </div>
  );
}

export default ViewUploadButton;
